'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var ZoomOption;
(function (ZoomOption) {
    ZoomOption[ZoomOption["Custom"] = 0] = "Custom";
    ZoomOption[ZoomOption["Auto"] = 1] = "Auto";
    ZoomOption[ZoomOption["Actual"] = 2] = "Actual";
    ZoomOption[ZoomOption["PageFit"] = 3] = "PageFit";
    ZoomOption[ZoomOption["PageWidth"] = 4] = "PageWidth";
    ZoomOption[ZoomOption["Percentage_50"] = 5] = "Percentage_50";
    ZoomOption[ZoomOption["Percentage_75"] = 6] = "Percentage_75";
    ZoomOption[ZoomOption["Percentage_100"] = 7] = "Percentage_100";
    ZoomOption[ZoomOption["Percentage_125"] = 8] = "Percentage_125";
    ZoomOption[ZoomOption["Percentage_150"] = 9] = "Percentage_150";
    ZoomOption[ZoomOption["Percentage_200"] = 10] = "Percentage_200";
    ZoomOption[ZoomOption["Percentage_300"] = 11] = "Percentage_300";
    ZoomOption[ZoomOption["Percentage_400"] = 12] = "Percentage_400";
})(ZoomOption || (ZoomOption = {}));
var CSS_UNITS = 96 / 72;
var VIEWER_CONTAINER = "page-viewer";
var PDF_VIEWER_BASE_HEIGHT = 792;
var PDF_VIEWER_BASE_WIDTH = 612;
var ToolbarBase = /** @class */ (function () {
    function ToolbarBase() {
    }
    ToolbarBase.prototype.getScaleFromZoomOption = function (zoomOption) {
        switch (zoomOption) {
            case ZoomOption.Custom:
                return 0;
            case ZoomOption.Auto:
                return this.getAutoScale();
            case ZoomOption.Actual:
                return 1;
            case ZoomOption.PageFit:
                return this.getPageFitScale();
            case ZoomOption.PageWidth:
                return this.getPageWidthScale();
            case ZoomOption.Percentage_50:
                return .5;
            case ZoomOption.Percentage_75:
                return .75;
            case ZoomOption.Percentage_100:
                return 1;
            case ZoomOption.Percentage_125:
                return 1.25;
            case ZoomOption.Percentage_150:
                return 1.5;
            case ZoomOption.Percentage_200:
                return 2;
            case ZoomOption.Percentage_300:
                return 3;
            case ZoomOption.Percentage_400:
                return 4;
            default:
                return 1;
        }
    };
    ToolbarBase.prototype.togglePanelClass = function (elementId) {
        var element = document.getElementById(elementId);
        if (element && element.classList.contains("collapsed")) {
            element.classList.remove("collapsed");
            element.classList.add("active-panel");
        }
        else {
            element && element.classList.add("collapsed");
            element && element.classList.remove("active-panel");
        }
    };
    ToolbarBase.prototype.openFullscreen = function () {
        var bodyElement = document.getElementsByTagName("body")[0];
        if (bodyElement.requestFullscreen) {
            bodyElement.requestFullscreen();
        }
        else if (bodyElement.mozRequestFullScreen) { /* Firefox */
            bodyElement.mozRequestFullScreen();
        }
        else if (bodyElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            bodyElement.webkitRequestFullscreen();
        }
        else if (bodyElement.msRequestFullscreen) { /* IE/Edge */
            bodyElement.msRequestFullscreen();
        }
    };
    ToolbarBase.prototype.closeFullscreen = function () {
        var doc = document;
        if (doc.exitFullscreen) {
            doc.exitFullscreen();
        }
        else if (doc.mozCancelFullScreen) { /* Firefox */
            doc.mozCancelFullScreen();
        }
        else if (doc.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            doc.webkitExitFullscreen();
        }
        else if (doc.msExitFullscreen) { /* IE/Edge */
            doc.msExitFullscreen();
        }
    };
    ToolbarBase.prototype.downloadFile = function (url, fileName, onAfterDownloadCallBack) {
        this.download(url, fileName, onAfterDownloadCallBack);
    };
    ToolbarBase.prototype.getAutoScale = function () {
        return screen.width >= 1200 ? 1 : (screen.width / 1200) + .10; // scree size >= 1200 is laptop so scale will be set to 1
    };
    ToolbarBase.prototype.getPageFitScale = function () {
        var viewerContainer = document.getElementById(VIEWER_CONTAINER);
        if (viewerContainer) {
            var scaleBasedOnHeight = viewerContainer.clientHeight / (PDF_VIEWER_BASE_HEIGHT * CSS_UNITS);
            var scaleBasedOnWidth = viewerContainer.clientWidth / (PDF_VIEWER_BASE_WIDTH * CSS_UNITS);
            return Math.min(scaleBasedOnHeight, scaleBasedOnWidth);
        }
        return 1;
    };
    ToolbarBase.prototype.getPageWidthScale = function () {
        var viewerContainer = document.getElementById(VIEWER_CONTAINER);
        if (viewerContainer) {
            return viewerContainer.clientWidth / (PDF_VIEWER_BASE_WIDTH * CSS_UNITS);
        }
        return 1;
    };
    ToolbarBase.prototype.download = function (url, filename, onAfterDownloadCallBack) {
        var a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", filename ? filename : "file.pdf");
        a.click();
        onAfterDownloadCallBack(filename);
    };
    return ToolbarBase;
}());

var Strings_Toolbar = /** @class */ (function () {
    function Strings_Toolbar() {
    }
    Strings_Toolbar.leftPaneToggleButtonTooltip = "Toggle Left Panel";
    Strings_Toolbar.rightPaneToggleButtonTooltip = "Toggle Right Panel";
    Strings_Toolbar.firstPageButtonTooltip = "First Page";
    Strings_Toolbar.previousPageButtonTooltip = "Previous Page";
    Strings_Toolbar.nextPageButtonTooltip = "Next Page";
    Strings_Toolbar.lastPageButtonTooltip = "Last Page";
    Strings_Toolbar.zoomOutButtonTooltip = "Zoom Out";
    Strings_Toolbar.zoomInButtonTooltip = "Zoom In";
    Strings_Toolbar.fullscreeButtonTooltip = "Full Screen";
    Strings_Toolbar.exitFullscreeButtonTooltip = "Exit Full Screen";
    Strings_Toolbar.readModeTooltip = "Read Mode";
    Strings_Toolbar.exitReadModeTooltip = "Exit Read Mode";
    Strings_Toolbar.downloadIconTooltip = "Download";
    return Strings_Toolbar;
}());

var Zoom = /** @class */ (function (_super) {
    __extends(Zoom, _super);
    function Zoom(props) {
        var _this = _super.call(this, props) || this;
        _this._toolbarBase = new ToolbarBase();
        _this.handleZoomOptionChange = function (event) {
            var scale = _this._toolbarBase.getScaleFromZoomOption(Number(event.target.value));
            _this.setState({ selectedZoomOption: event.target.value }, function () {
                _this.props.onZoomOptionChange && _this.props.onZoomOptionChange(scale);
            });
        };
        _this.handleZoomIn = function () {
            _this.setState({ selectedZoomOption: ZoomOption.Custom }, function () {
                _this.props.onZoomIn && _this.props.onZoomIn();
            });
        };
        _this.handleZoomOut = function () {
            _this.setState({ selectedZoomOption: ZoomOption.Custom }, function () {
                _this.props.onZoomOut && _this.props.onZoomOut();
            });
        };
        _this.state = {
            selectedZoomOption: ZoomOption.Auto
        };
        return _this;
    }
    Zoom.prototype.componentDidMount = function () {
    };
    Zoom.prototype.render = function () {
        return (React.createElement("div", { className: "icon-bar d-none d-sm-block" },
            React.createElement("a", { className: "icon", onClick: this.handleZoomOut, title: Strings_Toolbar.zoomOutButtonTooltip },
                React.createElement("i", { className: "fa fa-search-minus" })),
            React.createElement("a", { className: "icon", onClick: this.handleZoomIn, title: Strings_Toolbar.zoomInButtonTooltip },
                React.createElement("i", { className: "fa fa-search-plus" })),
            React.createElement("select", { className: "form-control toolbar-item-form-control toolbar-item-select ", title: "Zoom", onChange: this.handleZoomOptionChange, value: this.state.selectedZoomOption },
                React.createElement("option", { key: "pageCustomOption", id: "pageCustomOption", title: "", value: ZoomOption.Custom, disabled: true }, "Custom Zoom"),
                React.createElement("option", { key: "pageAutoOption", id: "pageAutoOption", title: "", value: ZoomOption.Auto }, "Automatic Zoom"),
                React.createElement("option", { key: "pageFitOption", id: "pageFitOption", title: "", value: ZoomOption.PageFit }, "Page Fit"),
                React.createElement("option", { key: "pageWidthOption", id: "pageWidthOption", title: "", value: ZoomOption.PageWidth }, "Page Width"),
                React.createElement("option", { key: ZoomOption.Percentage_50, title: "", value: ZoomOption.Percentage_50 }, "50%"),
                React.createElement("option", { key: ZoomOption.Percentage_75, title: "", value: ZoomOption.Percentage_75 }, "75%"),
                React.createElement("option", { key: ZoomOption.Percentage_100, title: "", value: ZoomOption.Percentage_100 }, "100%"),
                React.createElement("option", { key: ZoomOption.Percentage_125, title: "", value: ZoomOption.Percentage_125 }, "125%"),
                React.createElement("option", { key: ZoomOption.Percentage_150, title: "", value: ZoomOption.Percentage_150 }, "150%"),
                React.createElement("option", { key: ZoomOption.Percentage_200, title: "", value: ZoomOption.Percentage_200 }, "200%"),
                React.createElement("option", { key: ZoomOption.Percentage_300, title: "", value: ZoomOption.Percentage_300 }, "300%"),
                React.createElement("option", { key: ZoomOption.Percentage_400, title: "", value: ZoomOption.Percentage_400 }, "400%")),
            React.createElement("a", { className: "divider d-none d-sm-block" })));
    };
    Zoom.displayName = "Zoom";
    return Zoom;
}(React.Component));

var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePageChange = function (event) {
            if (event.key === 'Enter') {
                if (_this.validatePageNumber(Number(event.target.value))) {
                    _this.props.onGotoPage && _this.props.onGotoPage(Number(event.target.value));
                }
                else {
                    _this.props.onGotoPage && _this.props.onGotoPage(_this.props.totalPages != undefined ? _this.props.totalPages : 0);
                }
            }
        };
        _this.handleFirstPage = function () {
            _this.validatePageNumber(1) && _this.props.onFirstPage && _this.props.onFirstPage();
        };
        _this.handlePreviousPage = function () {
            _this.validatePageNumber((_this.props.currentPage != undefined ? _this.props.currentPage : 0) - 1) && _this.props.onPreviousPage && _this.props.onPreviousPage();
        };
        _this.handleNextPage = function () {
            _this.validatePageNumber((_this.props.currentPage != undefined ? _this.props.currentPage : 0) + 1) && _this.props.onNextPage && _this.props.onNextPage();
        };
        _this.handleLastPage = function () {
            _this.validatePageNumber((_this.props.totalPages != undefined ? _this.props.totalPages : 0)) && _this.props.onLastPage && _this.props.onLastPage();
        };
        _this.state = {
            currentPage: 0
        };
        return _this;
    }
    Pagination.prototype.componentDidMount = function () {
        this.setState({ currentPage: this.props.currentPage != undefined ? this.props.currentPage : 0 });
    };
    Pagination.prototype.componentWillUpdate = function (nextProps, nextState) {
        var currentPage = 0;
        if (this.state.currentPage !== nextState.currentPage) {
            currentPage = nextState.currentPage;
        }
        else {
            currentPage = nextProps.currentPage != undefined ? nextProps.currentPage : 0;
        }
        this.state.currentPage !== currentPage && this.setState({ currentPage: currentPage });
    };
    Pagination.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.state.currentPage !== nextState.currentPage
            || this.props.currentPage !== nextProps.currentPage
            || this.props.totalPages !== nextProps.totalPages) {
            return true;
        }
        return false;
    };
    Pagination.prototype.validatePageNumber = function (page) {
        if (page > 0 && page <= (this.props.totalPages != undefined ? this.props.totalPages : 0)) {
            return true;
        }
        return false;
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var disablePagination = this.props.disablePagination;
        return (React.createElement("div", { className: "icon-bar", style: { pointerEvents: disablePagination ? 'none' : 'auto' } },
            React.createElement("a", { className: this.props.currentPage == 1 || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.firstPageButtonTooltip, onClick: this.handleFirstPage },
                React.createElement("i", { className: "fa fa-angle-double-left" })),
            React.createElement("a", { className: this.props.currentPage == 1 || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.previousPageButtonTooltip, onClick: this.handlePreviousPage },
                React.createElement("i", { className: "fa fa-angle-left" })),
            React.createElement("a", { className: this.props.currentPage == this.props.totalPages || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.nextPageButtonTooltip, onClick: this.handleNextPage },
                React.createElement("i", { className: "fa fa-angle-right" })),
            React.createElement("a", { className: this.props.currentPage == this.props.totalPages || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.lastPageButtonTooltip, onClick: this.handleLastPage },
                React.createElement("i", { className: "fa fa-angle-double-right" })),
            React.createElement("input", { id: "pageNumber", type: "text", className: "form-control toolbar-item-form-control toolbar-item-text-box", onKeyDown: this.handlePageChange, value: this.state.currentPage, onChange: function (event) { !isNaN(event.target.value) && _this.setState({ currentPage: event.target.value }); }, disabled: this.props.totalPages == 0 || disablePagination }),
            React.createElement("label", { htmlFor: "pageNumber", className: "toolbar-item-label" },
                " of ",
                this.props.totalPages,
                " "),
            React.createElement("a", { className: "divider d-none d-md-block" })));
    };
    Pagination.displayName = "Pagination";
    return Pagination;
}(React.Component));

var LeftSection = /** @class */ (function (_super) {
    __extends(LeftSection, _super);
    function LeftSection(props) {
        return _super.call(this, props) || this;
    }
    LeftSection.prototype.componentDidMount = function () {
    };
    LeftSection.prototype.render = function () {
        return (React.createElement("div", { className: "left-section col-lg-2 col-md-1 col-sm-1 col-xs-1" }, this.props.children));
    };
    return LeftSection;
}(React.Component));

var MiddleSection = /** @class */ (function (_super) {
    __extends(MiddleSection, _super);
    function MiddleSection(props) {
        return _super.call(this, props) || this;
    }
    MiddleSection.prototype.componentDidMount = function () {
    };
    MiddleSection.prototype.render = function () {
        return (React.createElement("div", { className: "middle-section col-lg-8 col-md-10 col-sm-10 col-xs-10" }, this.props.children));
    };
    return MiddleSection;
}(React.Component));

var RightSection = /** @class */ (function (_super) {
    __extends(RightSection, _super);
    function RightSection(props) {
        return _super.call(this, props) || this;
    }
    RightSection.prototype.componentDidMount = function () {
    };
    RightSection.prototype.render = function () {
        return (React.createElement("div", { className: "right-section col-lg-2 col-md-1 col-sm-1 col-xs-1" }, this.props.children));
    };
    return RightSection;
}(React.Component));

var Draggabilly = require('draggabilly/draggabilly');
var DraggableToolBar = /** @class */ (function (_super) {
    __extends(DraggableToolBar, _super);
    function DraggableToolBar(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePageChange = function (event) {
            if (event.key === 'Enter') {
                if (_this.validatePageNumber(Number(event.target.value))) {
                    _this.props.onGotoPage(Number(event.target.value));
                }
                else {
                    _this.props.onGotoPage(_this.props.totalPages);
                }
            }
        };
        _this.handlePreviousPage = function () {
            if (_this.validatePageNumber(_this.props.currentPage - 1)) {
                _this.setState({ currentPage: _this.props.currentPage - 1 });
                _this.props.onPreviousPage();
            }
            else {
                _this.setState({ currentPage: 1 });
            }
        };
        _this.handleNextPage = function () {
            if (_this.validatePageNumber(_this.props.currentPage + 1)) {
                _this.setState({ currentPage: _this.props.currentPage + 1 });
                _this.props.onNextPage();
            }
            else {
                _this.setState({ currentPage: 1 });
            }
        };
        _this.state = {
            currentPage: 1
        };
        return _this;
    }
    DraggableToolBar.prototype.componentDidMount = function () {
        new Draggabilly('.read-mode-toolbar', {
            containment: "#page-viewer",
            handle: '.icon-move'
        });
    };
    DraggableToolBar.prototype.componentWillUpdate = function (nextProps, nextState) {
        var currentPage = nextProps.currentPage;
        if (this.state.currentPage !== nextState.currentPage) {
            currentPage = nextState.currentPage;
            this.setState({ currentPage: currentPage });
        }
    };
    DraggableToolBar.prototype.validatePageNumber = function (page) {
        if (page > 0 && page <= this.props.totalPages) {
            return true;
        }
        return false;
    };
    DraggableToolBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, onZoomOut = _a.onZoomOut, onZoomIn = _a.onZoomIn, onModeChange = _a.onModeChange;
        return (React.createElement("div", { className: "read-mode-toolbar" },
            React.createElement("div", { className: "icon-move" },
                React.createElement("i", { className: "fa fa-bars" })),
            React.createElement("div", { className: "read-mode-toolbar-items" },
                React.createElement("input", { type: "text", id: "toolbar-pages", className: "form-control toolbar-item-form-control toolbar-item-text-box", onKeyDown: this.handlePageChange, value: this.state.currentPage, onChange: function (event) { !isNaN(event.target.value) && _this.setState({ currentPage: event.target.value }); }, disabled: this.props.totalPages == 0 }),
                React.createElement("label", { htmlFor: "toolbar-pages", className: "toolbar-item-label" },
                    " of ",
                    this.props.totalPages,
                    " "),
                React.createElement("a", { onClick: this.handlePreviousPage },
                    React.createElement("i", { className: "fa fa-arrow-circle-o-up" })),
                React.createElement("a", { onClick: this.handleNextPage },
                    React.createElement("i", { className: "fa fa-arrow-circle-o-down" })),
                React.createElement("a", { className: "divider d-none d-sm-block" }),
                React.createElement("a", { onClick: onZoomOut },
                    React.createElement("i", { className: "fa fa-search-minus" })),
                React.createElement("a", { onClick: onZoomIn },
                    React.createElement("i", { className: "fa fa-search-plus" })),
                React.createElement("a", { className: "divider d-none d-sm-block" }),
                React.createElement("a", { onClick: onModeChange },
                    React.createElement("i", { className: "fa fa-compress" })))));
    };
    return DraggableToolBar;
}(React.Component));

var PDFJSViewer = require("pdfjs-dist/web/pdf_viewer");
var PDFJSThumbnailViewer = require("pdfjs-dist/lib/web/pdf_thumbnail_viewer");
var PDFJSOutlineViewer = require("pdfjs-dist/lib/web/pdf_outline_viewer");
var PDFJSLinkService = require("pdfjs-dist/lib/web/pdf_link_service");
var ViewerMode;
(function (ViewerMode) {
    ViewerMode[ViewerMode["Normal"] = 0] = "Normal";
    ViewerMode[ViewerMode["Read"] = 1] = "Read";
})(ViewerMode || (ViewerMode = {}));
var PageMode;
(function (PageMode) {
    PageMode[PageMode["SinglePage"] = 1] = "SinglePage";
    PageMode[PageMode["MultiPage"] = 2] = "MultiPage";
    PageMode[PageMode["Classic"] = 3] = "Classic";
})(PageMode || (PageMode = {}));
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    SearchResult.createNullObject = function () {
        var data = new SearchResult();
        data.matchCount = 0;
        data.pagesMatch = [];
        return data;
    };
    SearchResult.create = function (matchesCount, pagesMatches) {
        var data = new SearchResult();
        data.matchCount = matchesCount;
        data.pagesMatch = pagesMatches;
        return data;
    };
    return SearchResult;
}());
var PdfSource = /** @class */ (function () {
    function PdfSource() {
    }
    PdfSource.createNullObject = function () {
        return new PdfSource();
    };
    PdfSource.createFromUrl = function (url) {
        var data = new PdfSource();
        data.url = url;
        return data;
    };
    PdfSource.createFromBase64 = function (base64String) {
        var data = new PdfSource();
        data.base64String = base64String;
        return data;
    };
    return PdfSource;
}());
var PdfJSSource = /** @class */ (function (_super) {
    __extends(PdfJSSource, _super);
    function PdfJSSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PdfJSSource.createPDFDocumentProxy = function (pdfDocumentProxy) {
        var data = new PdfJSSource();
        data.pdfDocumentProxy = pdfDocumentProxy;
        return data;
    };
    return PdfJSSource;
}(PdfSource));

var CustomOptions = /** @class */ (function (_super) {
    __extends(CustomOptions, _super);
    function CustomOptions(props) {
        return _super.call(this, props) || this;
    }
    CustomOptions.prototype.render = function () {
        var _a = this.props.position, position = _a === void 0 ? "right" : _a;
        var styles = {
            float: position
        };
        return (React.createElement("div", { style: styles }, this.props.children));
    };
    CustomOptions.displayName = "CustomOptions";
    return CustomOptions;
}(React.Component));

var MATCHED_TEXT_COUNT_LIMIT_FOR_DISPLAY = 1000;
var SearchText = /** @class */ (function (_super) {
    __extends(SearchText, _super);
    function SearchText(props) {
        var _this = _super.call(this, props) || this;
        _this.timer = null;
        _this.handleChange = function (event) {
            var _self = _this;
            _self.setState({ textToFind: event.target.value }, function () {
                clearTimeout(_this.timer);
                _this.timer = setTimeout(function () {
                    _self.props.onSearch(_self.state.textToFind);
                }, 800);
            });
        };
        _this.getMatchFoundText = function () {
            var _a = _this.props, searchResult = _a.searchResult, currentPage = _a.currentPage, pageMode = _a.pageMode;
            var textToFind = _this.state.textToFind;
            var matchFoundStatusText = "";
            if (!textToFind) {
                return matchFoundStatusText;
            }
            if (pageMode == PageMode.SinglePage) { // Single page mode showing only text matched from current page
                var pageMatch = searchResult.pagesMatch.find(function (x) { return x.page == currentPage; });
                if (pageMatch) {
                    if (pageMatch.matchCount > MATCHED_TEXT_COUNT_LIMIT_FOR_DISPLAY) {
                        matchFoundStatusText = "More than 1000 matches found";
                    }
                    else {
                        matchFoundStatusText = pageMatch.matchCount + " matches found";
                    }
                }
                else {
                    matchFoundStatusText = "0 matches found";
                }
            }
            else { // multi page mode showing all matches from the document
                if (searchResult.matchCount > MATCHED_TEXT_COUNT_LIMIT_FOR_DISPLAY) {
                    matchFoundStatusText = "More than 1000 matches found";
                }
                else if (searchResult.matchCount <= MATCHED_TEXT_COUNT_LIMIT_FOR_DISPLAY) {
                    matchFoundStatusText = searchResult.matchCount + " matches found";
                }
                else {
                    matchFoundStatusText = "0 matches found";
                }
            }
            return matchFoundStatusText;
        };
        _this.state = {
            textToFind: ""
        };
        return _this;
    }
    SearchText.prototype.componentDidMount = function () {
    };
    SearchText.prototype.render = function () {
        return (React.createElement("div", { className: "icon-bar", style: { float: "right" } },
            React.createElement("input", { type: "text", id: "search-text-box", className: "form-control toolbar-item-form-control toolbar-item-search-text-box toolbar-item-search-text", value: this.state.textToFind, placeholder: "Find in document...", onChange: this.handleChange }),
            React.createElement("label", { htmlFor: "search-text-box", className: "toolbar-item-label" }, this.getMatchFoundText())));
    };
    SearchText.displayName = "SearchText";
    return SearchText;
}(React.Component));

var OtherOptions = /** @class */ (function (_super) {
    __extends(OtherOptions, _super);
    // private _toolbarBase: IToolbarBase = new ToolbarBase();
    function OtherOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            fullscreenEnabled: false
        };
        return _this;
    }
    OtherOptions.prototype.componentDidMount = function () {
    };
    // handleFullscreen = () => {
    //   if (this.state.fullscreenEnabled) {
    //     this._toolbarBase.closeFullscreen();
    //     this.setState({ fullscreenEnabled: false });
    //   }
    //   else {
    //     this._toolbarBase.openFullscreen();
    //     this.setState({ fullscreenEnabled: true });
    //   }
    // }
    OtherOptions.prototype.render = function () {
        var hideReadOnly = this.props.hideReadOnly;
        return (React.createElement("div", { className: "icon-bar  d-none d-md-block" }, !hideReadOnly && React.createElement("a", { className: "icon", onClick: this.props.onViewModeChange, title: this.state.fullscreenEnabled ? Strings_Toolbar.exitReadModeTooltip : Strings_Toolbar.readModeTooltip },
            React.createElement("i", { className: this.state.fullscreenEnabled ? "fa fa-compress" : "fa fa-expand" }))));
    };
    OtherOptions.displayName = "OtherOptions";
    return OtherOptions;
}(React.Component));

var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(props) {
        var _this = _super.call(this, props) || this;
        _this._toolbarBase = new ToolbarBase();
        _this.updateState = function (pageProperties) {
            _this.setState({
                currentPage: pageProperties.page,
                totalPages: _this._viewPanelRef.getTotalPages()
            });
        };
        //#region  Viewer Events
        _this.handleZoomIn = function () {
            if (_this.validateViewReference()) {
                _this._viewPanelRef.zoomIn();
                _this.props.onZoomIn && _this.props.onZoomIn();
            }
        };
        _this.handleZoomOut = function () {
            if (_this.validateViewReference()) {
                _this._viewPanelRef.zoomOut();
                _this.props.onZoomOut && _this.props.onZoomOut();
            }
        };
        _this.handleZoomChange = function (scale) {
            if (_this.validateViewReference()) {
                _this._viewPanelRef.zoomChange(scale);
                _this.props.onZoomOptionChange && _this.props.onZoomOptionChange(scale);
            }
        };
        _this.handleNextPage = function () {
            if (_this.validateViewReference()) {
                _this._viewPanelRef.nextPage();
                _this.props.onNextPageClick && _this.props.onNextPageClick();
            }
        };
        _this.handlePreviousPage = function () {
            if (_this.validateViewReference()) {
                _this._viewPanelRef.previousPage();
                _this.props.onPreviousPageClick && _this.props.onPreviousPageClick();
            }
        };
        _this.handleFirstPage = function () {
            if (_this.validateViewReference()) {
                _this.handleGotoPage(1);
                _this.props.onFirstPageClick && _this.props.onFirstPageClick();
            }
        };
        _this.handleLastPage = function () {
            if (_this.validateViewReference()) {
                _this.handleGotoPage(_this._viewPanelRef.getTotalPages());
                _this.props.onLastPageClick && _this.props.onLastPageClick();
            }
        };
        _this.handleGotoPage = function (page) {
            _this._viewPanelRef.gotoPage(page);
        };
        _this.handleSearchText = function (textToFind) {
            var _self = _this;
            _this._viewPanelRef.searchText(textToFind).then(function (searchResult) {
                _self.setState({ searchResult: searchResult });
                // _self._viewPanelRef.props.pageMode == PageMode.SinglePage && _self.handleGotoPage(_self.state.currentPage);
            });
        };
        _this.handleModeChange = function () {
            if (_this.state.ViewerMode == ViewerMode.Normal) {
                _this.setState({ ViewerMode: ViewerMode.Read }, function () {
                    _this._viewPanelRef.setViewerMode(_this.state.ViewerMode);
                    _this.props.onViewModeChange && _this.props.onViewModeChange(ViewerMode.Read);
                });
            }
            else {
                _this.setState({ ViewerMode: ViewerMode.Normal }, function () {
                    _this._viewPanelRef.setViewerMode(_this.state.ViewerMode);
                    _this.props.onViewModeChange && _this.props.onViewModeChange(ViewerMode.Normal);
                });
            }
            _this._viewPanelRef.resetCurrentStepFocus();
        };
        _this.handleDownload = function () {
            var _a = _this.props, downloadFileName = _a.downloadFileName, onDownload = _a.onDownload, onBeforeDownload = _a.onBeforeDownload, onAfterDownload = _a.onAfterDownload;
            onBeforeDownload && onBeforeDownload(_this._viewPanelRef.props.url != undefined ? _this._viewPanelRef.props.url : '');
            onDownload ? onDownload(_this._viewPanelRef.props.url != undefined ? _this._viewPanelRef.props.url : '') : _this._toolbarBase.downloadFile(_this._viewPanelRef.props.url != undefined ? _this._viewPanelRef.props.url : '', downloadFileName, onAfterDownload);
        };
        //#endregion
        //#region setReference Methods
        _this.setViewerReference = function (viewPanelRef) {
            _this._viewPanelRef = viewPanelRef;
        };
        //#endregion
        //#region Validate Reference region
        _this.validateViewReference = function () {
            if (!_this._viewPanelRef) {
                throw new Error("Please set the refrence of viewer in toolbar component by calling 'toolbarRef.setViewerReference()' ");
            }
            return true;
        };
        //#endregion
        _this.CreateMiddleSection = function () {
            var _self = _this;
            var controlCollection = [];
            React.Children.forEach(_this.props.children, function (child) {
                if (child.type.displayName == "Pagination") {
                    controlCollection.push(React.createElement(Pagination, { currentPage: child.props.currentPage == undefined ? _self.state.currentPage : child.props.currentPage, totalPages: child.props.totalPages == undefined ? _self.state.totalPages : child.props.totalPages, onFirstPage: child.props.onFirstPage != undefined ? child.props.onFirstPage : _self.handleFirstPage, onNextPage: child.props.onNextPage != undefined ? child.props.onNextPage : _self.handleNextPage, onPreviousPage: child.props.onPreviousPage != undefined ? child.props.onPreviousPage : _self.handlePreviousPage, onLastPage: child.props.onLastPage != undefined ? child.props.onLastPage : _self.handleLastPage, onGotoPage: child.props.onGotoPage != undefined ? child.props.onGotoPage : _self.handleGotoPage, disablePagination: child.props.disablePagination != undefined ? child.props.disablePagination : false }));
                }
                else if (child.type.displayName == "Zoom") {
                    controlCollection.push(React.createElement(Zoom, { onZoomOut: _self.handleZoomOut, onZoomIn: _self.handleZoomIn, onZoomOptionChange: _self.handleZoomChange }));
                }
                else if (child.type.displayName == "CustomOptions") {
                    controlCollection.push(React.createElement(CustomOptions, { position: child.props.position }, _self.props.customToolbarOptions));
                }
                else if (child.type.displayName == "SearchText" && _self.props.showTextSearch) {
                    controlCollection.push(React.createElement(SearchText, { pageMode: _self._viewPanelRef && _self._viewPanelRef.props.pageMode, currentPage: _self.state.currentPage, searchResult: _self.state.searchResult, onSearch: _self.handleSearchText }));
                }
                else if (child.type.displayName == "OtherOptions" && !_self.props.hideReadOnly) {
                    controlCollection.push(React.createElement(OtherOptions, { onViewModeChange: _self.handleModeChange, hideReadOnly: _self.props.hideReadOnly }));
                }
                else {
                    controlCollection.push(child);
                }
            });
            return controlCollection;
        };
        _this.handleTogglePanel = function (panel) {
            var _self = _this;
            _self._toolbarBase.togglePanelClass(panel);
            setTimeout(function () {
                _self._viewPanelRef && _self._viewPanelRef.resetCurrentStepFocus();
            }, 200);
        };
        _this.state = {
            totalPages: 0,
            currentPage: 1,
            ViewerMode: ViewerMode.Normal,
            searchResult: SearchResult.createNullObject()
        };
        return _this;
    }
    Toolbar.prototype.componentDidMount = function () {
    };
    Toolbar.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        nextProps = nextProps;
        if (this.state.currentPage !== nextState.currentPage
            || this.state.totalPages !== nextState.totalPages
            || this.state.ViewerMode !== nextState.ViewerMode
            || this.state.searchResult.matchCount !== nextState.searchResult.matchCount) {
            return true;
        }
        return false;
    };
    Toolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, hideLeftPanel = _a.hideLeftPanel, hideRightPanel = _a.hideRightPanel, showDownload = _a.showDownload;
        if (this.state.ViewerMode == ViewerMode.Read) {
            return (React.createElement(DraggableToolBar, { onGotoPage: this.handleGotoPage, onPreviousPage: this.handlePreviousPage, onNextPage: this.handleNextPage, onZoomIn: this.handleZoomIn, onZoomOut: this.handleZoomOut, onModeChange: this.handleModeChange, currentPage: this.state.currentPage, totalPages: this.state.totalPages }));
        }
        else {
            return (React.createElement("div", { className: "toolbar col-lg-12 no-padding" },
                React.createElement(LeftSection, null,
                    React.createElement("div", { className: "icon-bar" },
                        React.createElement("a", { className: "icon", hidden: hideLeftPanel, onClick: function () { _this.handleTogglePanel("left-panel"); }, title: Strings_Toolbar.leftPaneToggleButtonTooltip },
                            React.createElement("i", { className: "fa fa-columns" })))),
                React.createElement(MiddleSection, null, this.CreateMiddleSection()),
                React.createElement(RightSection, null,
                    React.createElement("div", { className: "icon-bar" },
                        React.createElement("a", { className: "icon", hidden: hideRightPanel, onClick: function () { _this.handleTogglePanel("right-panel"); }, title: Strings_Toolbar.rightPaneToggleButtonTooltip },
                            React.createElement("i", { className: "fa fa-columns" }))),
                    React.createElement("div", { className: "icon-bar" },
                        React.createElement("a", { className: "icon", hidden: !showDownload, onClick: this.handleDownload, title: Strings_Toolbar.downloadIconTooltip },
                            React.createElement("i", { className: "fa fa-download" }))))));
        }
    };
    return Toolbar;
}(React.Component));

exports.default = Toolbar;
exports.Toolbar = Toolbar;
